import React, { useState, useEffect, useContext } from "react";
import { SUB_USER_FEATURES } from "../../Library/constants";
import { Button } from "@chakra-ui/react";
import { updateSubUserFeaturePermission } from "../../APIs";
import { CloseIcon } from "../../Assets/images/svgs";
import { StoreContext } from "../../Library/contexts";

const ManageAccessCodes = ({ userDets, onClose, onSuccess, onFail }) => {
  const [selectedAccessCodes, setSelectedAccessCodes] = useState([]);
  const [initialAccessCodes, setInitialAccessCodes] = useState([]);
  const [saveDisabled, setSaveDisabled] = useState(true);
  const { setAllSubUsers } = useContext(StoreContext);

  useEffect(() => {
    const accessCodes = userDets?.accessCodes || [];
    setInitialAccessCodes(accessCodes);
    setSelectedAccessCodes(accessCodes);
  }, [userDets]);

  const handleCheckboxChange = (code) => {
    setSelectedAccessCodes((prevCodes) => {
      const updatedCodes = prevCodes.includes(code)
        ? prevCodes.filter((c) => c !== code)
        : [...prevCodes, code];

      setSaveDisabled(areEqual(initialAccessCodes, updatedCodes));
      return updatedCodes;
    });
  };

  const areEqual = (arr1 = [], arr2 = []) =>
    JSON.stringify([...arr1].sort()) === JSON.stringify([...arr2].sort());

  const handleSave = () => {
    setSaveDisabled(true);

    const payload = { uid: userDets.idx, ac: selectedAccessCodes };
    updateSubUserFeaturePermission(payload, (err, data) => {
      if (err) {
        console.error("Error Saving Feature Permissson's")
        setSaveDisabled(false);
        onClose();
        onFail();
      } else {
        setInitialAccessCodes([...selectedAccessCodes]);
        setSaveDisabled(true);
        onClose();
        onSuccess(data);
        setAllSubUsers((prevUsers) => prevUsers.map((subuser) =>
          subuser.idx === userDets.idx
            ? { ...subuser, accessCodes: [...selectedAccessCodes] }
            : subuser
        ));
      }
    })
  };

  return (
    <div className="mfp-body">
      <CloseIcon className="mfp-closeIcon" onClick={onClose}/>
      <div className="checkbox-list">
        {SUB_USER_FEATURES.map((code) => (
          <label key={code.value}>
            <input
              type="checkbox"
              checked={selectedAccessCodes.includes(code.value)}
              onChange={() => handleCheckboxChange(code.value)}
            />
            {code.label}
          </label>
        ))}
      </div>
      <div className="button-container">
        <Button className="save-btn" onClick={handleSave} disabled={saveDisabled}>Save</Button>
      </div>
    </div>
  );
};

export default ManageAccessCodes;
